import {Routes} from 'constants/routes';

import {AxiosResponse} from 'axios';
import {call, put} from 'redux-saga/effects';
import {createNewBeer} from 'services/beers';
import {setSuccessAC} from 'store/app/appSlice';
import {handleError} from 'store/app/error/saga';
import ApiData from 'typescript/interfaces/ApiData';
import {Beer} from 'typescript/models/Beer';

import {setCreatedBeerAC} from '../beerSlice';
import {createBeerACS} from '../requestAC';

export function* createBeer(action: ReturnType<typeof createBeerACS>) {
  const {dto, navigate} = action.payload;

  try {
    const response: AxiosResponse<ApiData<Beer>> = yield call(createNewBeer, dto);
    const newBeer = response.data.data;

    yield put(setCreatedBeerAC(newBeer));
    yield put(setSuccessAC('Beer created successfully'));
    if (navigate) navigate(`${Routes.BEERS_VIEW}/${newBeer.id}`);
  } catch (error) {
    yield call(handleError, error, 'Failed to create beer');
  }
}
